import { mapGetters } from "vuex"
import applyStoryblokMappers from "@soenergy/frontend-library/src/services/StoryblokFilter/applyStoryblokMappers"

export default {
  data() {
    return {
      story: { content: {} }
    }
  },
  head() {
    if (!this.content?.metadata || !this.websiteSettings) {
      return
    }
    const { title, description } = this.content.metadata
    return {
      title,
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_WEBSITE_URL + this.$route.path + (this.$route.path === "/" ? "" : "/")
        }
      ],
      meta: [
        {
          hid: "description",
          name: "description",
          content: description
        },
        {
          hid: "keywords",
          name: "keywords",
          content:
            "Great value energy, made easy gas, made easy electricity, dual fuel, cheap gas, cheap electricity, electric, cheap dual fuel, energy supplier, uk energy supplier, cheap energy tariffs, cheapest electricity, electric prices, switch gas, switch electric, fixed rate tariff, fixed tariff, so energy, soenergy"
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.websiteSettings.ogTitle
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.websiteSettings.ogDescription
        },
        {
          hid: "og:image",
          property: "og:image",
          content:
            this.websiteSettings.ogImage &&
            this.websiteSettings.ogImage.filename
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content:
            this.websiteSettings.ogImage && this.websiteSettings.ogImage.alt
        }
      ]
    }
  },
  computed: {
    ...mapGetters("contentManagement", ["websiteSettings"]),
    content() {
      return this.story.content
    }
  },
  created() {
    if (process.server) return
    // Existing mappers don't fully support Nuxt, as they internally use Proxy objects
    // which cannot be pre-rendered. A temporary fix is to re-run mappers on client side
    const isMappingNeeded =
      this.story.cmsVersion && this.story.cmsVersion !== "1"
    if (isMappingNeeded) {
      applyStoryblokMappers.applyMappers(this.story, this.story.cmsVersion)
    }
    this.setRouteEventsDefaults(this.story)
  },
  mounted() {
    this.$storyblokHelper.onInput(({ story }) => {
      if (this.story.id === story.id) {
        this.story.content = story.content
      } else {
        this.$store.dispatch("contentManagement/applyPreviewChanges", story)
      }
    })
    this.bypassEnrollmentLock()
  },
  methods: {
    setRouteEventsDefaults(story) {
      if (this.$analytics) {
        this.$analytics.setRouteEventsDefaults(
          story.path || story.full_slug,
          story.content.analyticsEventDefaults
        )
      }
    },
    bypassEnrollmentLock() {
      if (
        process.client &&
        this.$cookies.get("bypass_enrollment_flag") === "HS@(d3&+^kw9"
      ) {
        this.$store.commit(
          "contentManagement/SET_PROSPECT_SWITCH_JOURNEY_STATUS",
          true
        )
      }
    }
  }
}
